import { useMutation } from '@tanstack/react-query';
import { fetchApi } from '@/std/api/fetchApi';
import type { TabelaPrecoBody } from '../types/TabelaPrecoBody';
import { invalidateTabelaPrecoQueries } from '../util/invalidateTabelaPrecoQueries';

function apiTabelaPrecoAlterar({ idpk, body }: { idpk: number; body: TabelaPrecoBody }) {
    return fetchApi({
        body,
        endpoint: 'TabelaPreco/Alterar',
        idpk,
        method: 'put',
        schema: null,
    });
}

export function useMutationTabelaPrecoAlterar() {
    return useMutation({
        mutationFn: apiTabelaPrecoAlterar,
        onSuccess: invalidateTabelaPrecoQueries,
    });
}
